import { consoleLog } from "../../../utils/log-utils";
import {
  listRequest,
  createUpdateRequest,
  categoryTagListRequest,
  updateTags,
  deleteCategory,
} from "../../service/CategoryService";

/**
 *
 * @param {*} data  JSON DATA TO SEND TO SERVER
 * @returns API RESULT
 */
export const listAction = (data) => async (dispatch) => {
  const response = await dispatch(listRequest(data));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const taglistAction = (data) => async (dispatch) => {
  const response = await dispatch(categoryTagListRequest(data));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const tagUpdateAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(updateTags(requestBody));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const createUpdateAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(createUpdateRequest(requestBody));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const deleteCategoryAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(deleteCategory(requestBody));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
